import {useCallback, useEffect} from "react";

export default function ClickOutside({refElement, onOutsideClick, exceptElements}) {

    const handleClickOutside = useCallback((event) => {
        if (refElement && refElement?.current && !refElement?.current?.contains(event.target) &&
            (!exceptElements || (exceptElements?.current && !exceptElements?.current?.contains(event.target)))) {
            onOutsideClick();
        }
    }, [refElement, onOutsideClick, exceptElements]);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [refElement]);

    return null
}
